import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import axios from "axios"
import Button from '@mui/material/Button';
import Table from "react-bootstrap/Table"
import "datatables.net-dt/css/dataTables.dataTables.min.css"
import DataTable from "datatables.net-dt/js/dataTables.dataTables.min.js"
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {NavLink} from 'react-router-dom'

const DeleteTreatment = () => {
    const[data,setData]=useState([])
   useEffect(()=>{
    axios.get(`https://backendsurgylife-1.onrender.com/uploads`)
    .then((res)=>{
      setData(res.data)
    })
    .catch((err)=>{
      alert("Error Fetching Treatment")
    })
    setTimeout(()=>{
      new DataTable('#treatmentTable')
    },1000)
  
  })
  
  const deleteTreatmentData =(tid)=>{
    axios.delete(`https://backendsurgylife-1.onrender.com/uploads/${tid}`)
    .then((res)=>{
      alert("Treatment Deleted Successfully")
    })
    .catch((err)=>{
      alert("Error Deleting Treatment")
    })
  }



  return (
   <main>
  

      <section>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
 <Table striped bordered hover id='treatmentTable'>
      <thead>
        <tr>
          <th>T.Image</th>
          <th>T.Name</th>
         <th>T.Desc</th>
         <th>Action</th>

        </tr>
      </thead>

      <tbody>
         {
          data.map((treatment)=>{
          return(
            <tr key={treatment._id}>
                  <td>
                      <img
                     src={`https://backendsurgylife-1.onrender.com/${treatment.filename}`}
                     style={{width:350}}
                     className='img-fluid'
                     />
                  </td>
                    
              <td>{treatment.tname}</td>
              <td>{treatment.tdesc}</td>

          
                <td className='d-flex  justify-content-center  '>
      <Button variant="contained" color='error' className='me-3' onClick={()=>{deleteTreatmentData(treatment._id)}}>
        <DeleteIcon/>
      </Button>


      <Button 
                       variant="outlined"
                        color='success'
                       >
                        <NavLink to={`/edittreatment/${treatment._id}`}>
                                <EditIcon/>
                        </NavLink>
               
                          </Button>

                </td>
            </tr>
          )
          })
         }
          </tbody>
    </Table>
            </div>
          </div>
        </div>
      </section>

    </main>  )
}

export default DeleteTreatment
